<template><div></div></template>
<script>
import { spine } from "@/lib/spine-player.js";
import "@/lib/spine-player.css";
export default {
  name: "AnimationSpineBaseFunctions",
  data() {
    return {
      spinePlayer: null,
      coinPlayer: null,
      containerOpacity: 0,
      coinJson: "/assets/spines/chest/missions-ani-chest-coinfireworks.json",
      coinAtlas: "/assets/spines/chest/missions-ani-chest-coinfireworks.atlas",
    };
  },
  beforeDestroy() {
    this.disposeSpinePlayer(this.spinePlayer);
    this.spinePlayer = null;
    this.disposeSpinePlayer(this.coinPlayer);
    this.coinPlayer = null;
  },

  methods: {
    disposeSpinePlayer(player) {
      if (!player) return;
      player.stopRendering();
      if (player.dom && player.dom.parentNode) {
        player.dom.parentNode.removeChild(player.dom);
      }
    },
    activateAnimation(animationName, loop) {
      if (!this.spinePlayer) return;
      this.spinePlayer.animationState.setAnimation(0, animationName, loop);
    },
    setupAnimation(animationName, successCallback, customViewport) {
      this.disposeSpinePlayer(this.spinePlayer);
      this.spinePlayer = null;

      let viewport;
      if (customViewport) {
        const containerElement = document
          .getElementById(this.containerId)
          .getBoundingClientRect();
        viewport = {
          debugRender: false,
          x: containerElement.left,
          y: containerElement.top,
          width: containerElement.width,
          height: containerElement.height,
          padLeft: 0,
          padRight: 0,
          padTop: 0,
          padBottom: 0,
        };
      } else {
        viewport = {
          debugRender: false,
        };
      }
      const player = new spine.SpinePlayer(this.containerId, {
        jsonUrl: this.json,
        atlasUrl: this.atlas,
        showControls: false,
        animation: animationName,
        premultipliedAlpha: true,
        backgroundColor: "#00000000",
        alpha: true,
        viewport: viewport,
        showLoading: false,

        error: () => {
          console.error("Error loading spine animation");
        },
        success: () => {
          // Assets can land after the component is gone; success callbacks read
          // this.spinePlayer, which beforeDestroy has already nulled.
          if (this._isDestroyed || this._isBeingDestroyed) return;
          successCallback(player);
        },
      });

      this.spinePlayer = player;
    },
    initializeCoin() {
      this.containerOpacity = 0;
      this.disposeSpinePlayer(this.coinPlayer);
      this.coinPlayer = null;

      const coinPlayer = new spine.SpinePlayer(this.coinContainerId, {
        jsonUrl: this.coinJson,
        atlasUrl: this.coinAtlas,
        showControls: false,
        animation: "Coins-Flying",
        premultipliedAlpha: true,
        backgroundColor: "#00000000",
        alpha: true,
        viewport: {
          debugRender: false,
        },
        error: () => {
          console.error("Error loading spine animation");
        },
        success: () => {
          if (this._isDestroyed || this._isBeingDestroyed) return;
          coinPlayer.animationState.setAnimation(
            0,
            "Coins-Flying",
            this.loopCoins
          );
          coinPlayer.animationState.timeScale = 1;
          this.containerOpacity = 1;
        },
      });

      this.coinPlayer = coinPlayer;

      return coinPlayer;
    },
    onSuccess() {
      this.containerOpacity = 1;
    },
  },
};
</script>

<style lang="scss"></style>
